import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import ET3Div from "../../core/et3-div";
import i18n from "../../constants/i18n";
import Et3Image from "../../core/et3-Image";
import { SIDE_BAR_WIDTH } from "../side-bar/side-bar-constants";
import {
  HEADER_BRAND_BACKDROP,
  HEADER_HEIGHT,
  HEADER_LOGO_MONOCHROME_FILTER,
  HEADER_LOGO_SIZE,
  HEADER_PADDING_X
} from "./header-constants";

const KhatabaIcon = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={SIDE_BAR_WIDTH}
      height={HEADER_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.darkSlateGray}
      style={{
        boxSizing: "border-box",
        position: "absolute",
        left: 0,
        top: 0,
        backgroundImage: HEADER_BRAND_BACKDROP,
        overflow: "hidden",
        flexShrink: 0,
        paddingLeft: HEADER_PADDING_X * unitX,
        paddingRight: HEADER_PADDING_X * unitX
      }}
      onClick={() => {}}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={"et3-logo"}
        size={HEADER_LOGO_SIZE}
        onClick={() => {}}
        style={{
          filter: HEADER_LOGO_MONOCHROME_FILTER,
          maxWidth: "100%",
          flexShrink: 1
        }}
      />
    </ET3Div>
  );
});
export default KhatabaIcon;
